var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.admin_theme_loaded)?_c('div',{staticClass:"bg-labPrimary",attrs:{"id":"app"}},[_c('ButtonsWidget'),_c('router-view'),_c('LiveChatWidgetCustom')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }